import { AxiosError, AxiosResponse } from 'axios';
import { Box, Center, Text } from '@chakra-ui/react';
import { useGoogleLogin } from '@react-oauth/google';
import { authControllerGoogleLogin } from '@/generated/auth/auth';
import { AuthLoginDto } from '@/generated/nabisNYWebAPI.schemas';
import { colors } from '@/styles/theme/foundations/colors';
import { typography } from '@/styles/theme/foundations/typography';
import Image from 'next/image';

export interface Props {
  onAuthSuccess: (authResult: AxiosResponse<AuthLoginDto>) => void;
  onAuthError: (e: AxiosError<{ errors: Record<string, string> }>) => void;
  onGoogleError?: () => void;
  disabled?: boolean;
}
export const GoogleOauthLogin = ({ onAuthSuccess, onAuthError, disabled, onGoogleError }: Props) => {
  const login = useGoogleLogin({
    onSuccess: (credentialResponse) => {
      authControllerGoogleLogin({ accessToken: credentialResponse.access_token })
        .then(onAuthSuccess)
        .catch(onAuthError);
    },
    onError: onGoogleError || (() => alert('Login Failed')),
  });

  if (disabled) {
    return <></>;
  }

  return (
    <Box
      w="100%"
      backgroundColor={colors.background.nestedContainer.dark}
      p={3}
      borderRadius="lg"
      textAlign="center"
      cursor="pointer"
      onClick={() => login()}
    >
      <Center>
        <Image src="/google.svg" alt="Google" height={20} width={20} style={{ display: 'inline' }} />
        <Text pl={4} style={{ ...typography.textStyles.bodyStrong, display: 'inline' }} color={colors.text.base.dark}>
          Sign in with Google
        </Text>
      </Center>
    </Box>
  );
};
